'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var _ref$data = _ref.data,
      jobs = _ref$data.jobs,
      subsectors = _ref$data.subsectors;
  var route = _ref2.route;

  var job = jobs[route.split('/').pop()];
  var subsector = subsectors[job.subsectors[0]];
  return {
    subsector: subsector
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/ViewThisJob/selectors.js
// module id = 1280
// module chunks = 0